<template>

    <w-flex wrap class="text-center basis-zero">
        <br />
        <div class="xs2 pa2">
            <div class="w-app">
                <w-card title="Shopping Cart" title-class="primary-dark1--bg">
                    <w-table style="margin: auto;" :headers="partsList.headers" :items="partsList.items"
                        :mobile-breakpoint="600" :loading="partsList.loading" fixed-headers>
                        <template #no-data>👌 There is no data! 👌</template>
                        <template #item="{ item, index, select, classes }">
                            <tr :class="classes" @click="select">
                                <td v-for="(header, i) in partsList.headers" :key="i" :style="item.style">
                                    <img v-if="header.label == ' '" :src="item.imageThumbnail"
                                        style=" padding: 3px 3px 0px 3px;" />
                                    {{ item[header.key] || '' }}
                                    <div v-if="header.label == 'Remove'">
                                        <w-button icon="mdi mdi-delete" text lg class="ml3" bg-color="warning" outline
                                            @click="clearItem(item)"></w-button>
                                    </div>
                                    <div v-if="header.label == 'QTY'">
                                        <w-button icon="mdi mdi-minus" text lg class="ml3" bg-color="warning" outline
                                            @click="removeItem(item)"></w-button>
                                        <w-button icon="mdi mdi-plus" text lg class="ml3" bg-color="warning" outline
                                            @click="addItem(item)"></w-button>
                                    </div>
                                    <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                                        v-if="header.label == 'In Stock' && item.inStock == 'true'"></div>
                                    <div class="mdi mdi-close-circle" style="color:red"
                                        v-if="header.label == 'In Stock' && item.inStock == 'false'"></div>
                                    <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                                        v-if="header.label == 'Special Order' && item.specialOrder == true"></div>
                                    <div class="mdi mdi-close-circle" style="color:red"
                                        v-if="header.label == 'Special Order' && item.specialOrder == 'false'"></div>
                                    <div v-if="header.label == 'Special Order' && item.specialOrderTwoWeeks == true">
                                        Under Two Weeks
                                    </div>
                                    <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                                        v-if="header.label == 'Obsolete' && item.obsolete == true"></div>
                                    <div class="mdi mdi-close-circle" style="color:red"
                                        v-if="header.label == 'Obsolete' && item.obsolete == 'false'"></div>
                                </td>
                            </tr>
                        </template>
                        <!-- <template #item-cell="{ item, label, header }">
                            <div v-if="header.label == ' '">
                                <img :src="item.imageThumbnail" />
                            </div>
                            <div :style="item.style">{{ label }}</div>
                        </template> -->
                    </w-table>
                    <w-button icon="mdi mdi-delete" text lg class="ml3" bg-color="warning" outline
                        @click="clearList()"></w-button>
                </w-card>
            </div>
        </div>
    </w-flex>
    <!-- {{ cartItems }} -->
    <!-- <button @click="add()">test</button> -->
</template>


<script>
import { useCartStore } from "../store/cart";
import { ref, watch } from "vue";
import { storeToRefs } from 'pinia'
export default {
    name: "Cart",

    data() {

        let Cart = ref(useCartStore().getItems())
        // let cartItems = storeToRefs(useCartStore())
        watch(useCartStore(), (newValue, oldValue) => {
            //     Cart.value = useCartStore().getItems()
            partsList.value.items = newValue.cartItems
            console.log('some changed', newValue)

        })
        let partsList = ref({
            headers: [
                { label: " ", key: "id ", align: "center" },
                { label: "Part Number", key: "alternative", align: "center" },
                { label: "Description", key: "description", align: "center" },
                { label: "Manufacture Code", key: "manufactureCode", align: "center" },
                { label: "Brand", key: "brand", align: "center" },
                { label: "Price", key: "unitPrice", align: "center" },
                { label: "QTY", key: "qty", align: "center" },

                // { label: "FullPrice", key: "fullPrice", align: "center" },
                { label: "Obsolete", key: "obsoletes", align: "center" },
                { label: "Special Order", key: "specialOrders", align: "center" },
                { label: "In Stock", key: "inStocks", align: "center" },
                // { label: "imageThumbnail", key: "imageThumbnail", align: "center" },
                // { label: "image", key: "image", align: "center" },
                { label: "Supplier", key: "supplierName", align: "center" },
                { label: "Remove", key: "remove", align: "center" },
            ],
            items: Cart,
            loading: false,
        });
        function addItem(item) {
            useCartStore().addItem(item)
        }

        function removeItem(item) {
            useCartStore().removeItem(item)
            // console.log("Removing", item);
        }
        function clearItem(item) {
            useCartStore().clearItem(item)
            // console.log("Removing", item);
        }
        function clearList() {
            useCartStore().clearAll()
            console.log("Removing", "All");
        }

        return {
            Cart,
            partsList,
            addItem,
            removeItem,
            clearItem,
            clearList

        }
    }
}

</script>
<style scoped>
div.w-table-wrap {

    height: 25vh;

}
</style>
